export class SignIn {
    password: string;
    mobileNumber: number;
    emailId: string;
    guestCustomer: boolean;
}
